export default __webpack_public_path__ + "static/nutrition-data-80cad0c438fd87fdb83f6d7134e296e1.png";